import SCHEDULE_CONTEXT from 'constants/schedule-context';
import get from 'lodash-es/get';

const SET_TOKEN = 'classpass/user/SET_TOKEN';
const SET_SCHEDULE_CONTEXT = 'classpass/user/SET_SCHEDULE_CONTEXT';

export const isLoggedIn = state => get(state, 'user.loggedIn') || false;
export const setToken = (token, request) => ({ type: SET_TOKEN, data: token, request });
export const setScheduleContext = context => ({ type: SET_SCHEDULE_CONTEXT, data: context });

const initialState = {
  loggedIn: false,
  token: null,
  viewingNextCycle: false,
  scheduleContext: SCHEDULE_CONTEXT.CURRENT_CYCLE,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_TOKEN:
      if (action.request) {
        action.request.session.authToken = action.data;
      }
      return {
        ...state,
        loggedIn: !!action.data,
        token: action.data,
      };
    case SET_SCHEDULE_CONTEXT:
      return {
        ...state,
        viewingNextCycle: action.data === SCHEDULE_CONTEXT.NEXT_CYCLE,
        scheduleContext: action.data,
      };
    default:
      return state;
  }
}
